module.exports = __webpack_public_path__ + "img/terradrone_g.514c9618.png";